'use client'

import { usePWA } from '@/hooks/usePWA'
import { WifiOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useI18n } from '@/lib/i18n'

export function OfflineBanner() {
  const { isOnline } = usePWA()
  const { t } = useI18n()

  if (isOnline) return null

  return (
    <div
      className={cn(
        'fixed top-0 left-0 right-0 z-50',
        'bg-warning text-warning-foreground text-center py-2 px-4',
        'flex items-center justify-center gap-2 text-sm font-medium',
        'animate-in slide-in-from-top duration-300'
      )}
    >
      <WifiOff className="h-4 w-4" />
      <span>{t('common.offlineMessage')}</span>
    </div>
  )
}
